export enum ErrorsRouteName {
    NotFound = 'not-found',
    ServerError = 'server-error'
}
